import React from 'react';

export const ClickUpSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 27.657L12.5053 23.8889C14.914 27.2706 17.4566 28.8648 20.2668 28.8648C23.077 28.8648 25.575 27.3189 27.85 23.9372L32.4444 27.6087C29.1436 32.4396 25.0397 35 20.2668 35C15.5385 35 11.3901 32.4396 8 27.657Z"
			fill="url(#paint0_linear_click_up)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.2222 12.5343L11.8572 19.4444L8 15.12L20.2687 5L32.4444 15.12L28.5408 19.3999L20.2222 12.5343Z"
			fill="url(#paint1_linear_click_up)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_click_up"
				x1="8"
				y1="29.4499"
				x2="32.4643"
				y2="29.4499"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#8930FD" />
				<stop offset="1" stopColor="#49CCF9" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_click_up"
				x1="7.99782"
				y1="12.2197"
				x2="32.4187"
				y2="12.2197"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF02F0" />
				<stop offset="1" stopColor="#FFC800" />
			</linearGradient>
		</defs>
	</svg>
);
